import { useEffect, useState } from "react";

/**
 * Returns true if the current device is likely mobile / touch-based.
 * Detects via:
 *  - CSS media query max-width: 768px (bootstrap md breakpoint)
 *  - OR pointer:coarse (finger touch input)
 *  - OR navigator.maxTouchPoints > 0
 *
 * Re-evaluates on resize / orientationchange.
 */
export default function useIsMobile() {
  const compute = () => {
    if (typeof window === "undefined") return false;
    const narrow = window.matchMedia("(max-width: 768px)").matches;
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    const touch = (navigator?.maxTouchPoints || 0) > 0;
    return narrow || coarse || touch;
  };
  const [isMobile, setIsMobile] = useState(compute);
  useEffect(() => {
    const onChange = () => setIsMobile(compute());
    window.addEventListener("resize", onChange);
    window.addEventListener("orientationchange", onChange);
    return () => {
      window.removeEventListener("resize", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, []);
  return isMobile;
}
